export default __webpack_public_path__ + "static/media/stock-blockchain.013e0de7.jpg";